import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import RemindersTable from "../components/tables/RemindersTable.jsx";

export function RemindersPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Erinnerungen", path: "/reminders" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        pt: 0,
        pb: 6,
      }}
    >
      <Box>
        <Typography variant="h1">Meine Erinnerungen</Typography>
      </Box>

      <RemindersTable />
    </Box>
  );
}
